import { useMemo } from 'react';
import { analyzeContent, ContentAnalysis } from '../utils/codeBlockUtils';

/**
 * Analyzes code content for display purposes
 */
export default function useCodeBlockContent(
  content: string,
  maxContentHeight: number,
): ContentAnalysis {
  return useMemo(() => analyzeContent(content, maxContentHeight), [content, maxContentHeight]);
}
